import React, { useEffect, useRef } from 'react'

import * as d3 from 'd3'

import * as style from './data-slide.module.scss'

const DataGraph = ({ data, title, axisY, inView }) => {
  const ref = useRef(null)

  useEffect(() => {
    const config = {
      width: 800,
      height: 320
    }

    const margin = { top: 24, right: 32, bottom: 64, left: 40 },
      width = config.width - margin.left - margin.right,
      height = config.height - margin.top - margin.bottom

    const svgContainer = d3.select(ref.current)

    svgContainer.selectAll('*').remove()

    const parseDate = d3.timeParse('%Y-%m-%d')
    const formatDate = d3.timeFormat('%b-%y')

    data = data.map((d) => {
      return {
        label: parseDate(d.label),
        value: d.value
      }
    })

    // Create the SVG container.
    const svg = svgContainer
      .append('svg')
      .attr('width', width)
      .attr('height', height)
      .attr('viewBox', [0, 0, width, height])
      .attr('style', 'max-width: 100%; height: auto; width: 100%')

    // Declare the x (horizontal position) scale.
    const x = d3
      .scaleTime()
      .domain(d3.extent(data, (d) => d.label))
      .range([margin?.left, width - margin?.right])

    const xAxis = d3
      .axisBottom(x)
      .tickValues(data.map((d) => d.label))
      .tickFormat(formatDate)
      .tickSize(0)
      .tickPadding(5)

    // Declare the y (vertical position) scale.
    const y = d3
      .scaleLinear()
      .domain(axisY || [0, d3.max(data, (d) => d.value)])
      .range([height - margin?.bottom, margin?.top])

    const line = d3
      .line()
      .x((d) => x(d.label))
      .y((d) => y(d.value))

    // Add the x-axis and label.
    svg
      .append('g')
      .attr('transform', `translate(0,${height - margin?.bottom})`)
      .call(xAxis)
      .call((g) => g.select('.domain').remove())
      .selectAll('text')
      .style('text-anchor', 'end')
      .attr('dx', '-0.8em')
      .attr('dy', '-0em')
      .attr('transform', 'rotate(-90)')
      .attr('class', style.lineXAxis)

    // Add the y-axis and label, and remove the domain line.
    svg
      .append('g')
      .attr('transform', `translate(${margin?.left},0)`)
      .call(d3.axisLeft(y).ticks(10).tickSize(0).tickPadding(10))
      .call((g) => g.select('.domain').remove())
      .attr('class', style.lineYAxis)

    svg
      .selectAll('line.grid')
      .data(y.ticks(10))
      .enter()
      .append('line')
      .attr('class', style.gridLine)
      .attr('x1', margin?.left)
      .attr('x2', width - margin.right)
      .attr('y1', (d) => y(d))
      .attr('y2', (d) => y(d))

    // Add the line
    svg
      .append('path')
      .datum(data) // Asigna los datos a la línea
      .attr('class', 'line')
      .attr('d', line)
      .attr('fill', 'none')
      .attr('stroke-width', 4)
      .attr('stroke', 'var(--brand-primary-lighter)')
      .attr('opacity', '0')

    // Set opacity to 1 when inView is true
    if (inView) {
      svg.select('.line').transition().duration(500).attr('opacity', '1')
    }
  }, [inView])

  return (
    <>
      <h4 className="b200-bold text-base-000 text-center">{title}</h4>
      <div ref={ref} />
    </>
  )
}

export default DataGraph
